<template>
    <div id="app" class="main-wrap">
        <keep-alive>
            <router-view class="router-view" v-if="this.$route.meta.keepAlive" @showSharePopup="_showSharePopup" @showLoginDialog="_showLoginDialog" @showBindMobilePopup="_showBindMobilePopup" />
        </keep-alive>
        <router-view class="router-view" v-if="!this.$route.meta.keepAlive" @showSharePopup="_showSharePopup" @showLoginDialog="_showLoginDialog" @showBindMobilePopup="_showBindMobilePopup" />
        <login-dialog ref="loginDialogRef" />
        <share-popup ref="sharePopupRef" />
        <bind-mobile-popup ref="bindMobilePopupRef" />
        <div class="btn-item home-btn-item pos-f flex ccc tran03 z9999" :class="{cur: is_share > 0 }" @click="onNavigateToHome">
            <img class="btn-icon" :src="Images.icon_home" />
            <div class="btn-title">去首页</div>
        </div>
    </div>
</template>
<script>
import { wxShare } from '@/utils/wxShare'
import SharePopup from '@/components/popup/SharePopup'
import LoginDialog from '@/components/login/LoginDialog'
import BindMobilePopup from '@/components/popup/BindMobilePopup'

export default {
    name: 'app',
    components: {
        SharePopup,
        LoginDialog,
        BindMobilePopup,
    },
    data() {
        return {
            SCOPE: 'snsapi_userinfo',
            STATE: 'userinfo',
            is_share: 0,
        }
    },
    created() {},
    mounted() {
        // 初始化微信设置
        this._setupWechatConfig();
        // this._onWechatLogin();
        this._initialData();
    },
    watch: {
        $route(to, from) {
            this.is_share = this.$route.query.is_share;
            console.log('hhhhh this.is_share2---->', this.is_share);
        }
    },
    methods: {

        _initialData() {
            console.log('window.location.href---->', window.location.href);
            setTimeout(() => {
                this.id = this.$route.query.id;
                this.is_share = this.$route.query.is_share;
                console.log('this.is_share---->', this.is_share, this.id);
            }, 1500);
        },

        async _setupWechatConfig() {
            let url = this.API.wx_setup_info;
            let data = {
                page_flag: 'common',
                share_url: window.location.href.split('#')[0],
            };

            // 非微信环境直接退出
            if (!this.$isWeiXin()) return;
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                wxShare(result.data.share_config, result.data.share_params, () => {});
            }
        },

        // 微信中打开直接登录
        async _onWechatLogin() {
            console.log('_onWechatLogin 111---->', '111');

            let token = await this.Lockr.get('token');
            let code = this.getParamer('code');
            console.log('_onWechatLogin 222, token---->', token, code);

            if (!!token || !!code) {
                console.log('_onWechatLogin 333---->', '333 已授权，直接跳转');
                return;
            }

            if (this.$isWeiXin()) {
                console.log('_onWechatLogin 444---->', '444');
                let APPID = this.Constants.WECHAT_APPID;
                let REDIRECT_URI = encodeURIComponent(this.API.HOST_H5);
                let SCOPE = this.SCOPE
                let STATE = this.STATE
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=${SCOPE}&state=${STATE}#wechat_redirect`
            }
        },

        // 未登录时显示登录弹窗
        _showLoginDialog(value) {
            console.log('_showLoginDialog---->', value);
            this.$refs.loginDialogRef._show(value);
        },
        // 分享提示弹窗
        _showSharePopup(value) {
            console.log('_showLoginDialog---->', value);
            this.$refs.sharePopupRef._show(value);
        },
        // 绑定手机号弹窗
        _showBindMobilePopup(value) {
            console.log('_showLoginDialog---->', value);
            this.$refs.bindMobilePopupRef._show(value);
        },
        // 回到首页
        onNavigateToHome() {
            this.$router.replace("/");
        },
    },
}


function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return (false);
}

// 获取url参数
function getParamer(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) return unescape(r[2]);
    return null; //返回参数值
}
</script>
<style lang="less">
* {
    margin: 0;
    padding: 0;
}

#app {
    font-family: Microsoft YaHei, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100vh;
    background: #f8f8f8;
}

.pswp__bg,
.pswp {
    background: #fff !important;
}

input {
    border: 0;
    background: unset;
}

input:focus {
    border: 0;
    outline: 0;
}

.home-btn-item {
    width: 5rem;
    right: -5rem;
    height: 5rem;
    bottom: 6rem;
    border-radius: 50%;
    background: linear-gradient(45deg, #7180eb, #d3d5e6);
    box-shadow: 0px 1px 6px 0px rgba(157, 157, 157, 0.2);

    &.cur {
        right: 3rem;
    }

    .btn-icon {
        width: 2rem;
        height: 2rem;
        object-fit: contain;
        filter: brightness(5);
    }

    .btn-title {
        color: #fff;
        font-size: 1.1rem;
    }

}

.tangram-suggestion-main {
    z-index: 99999;
}
</style>